var _defs, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTrain(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:none;fill-rule:evenodd;}.b{fill:#e6007e;}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M0,0H24V24H0Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M4.091,12.5v-1h16v1ZM19.591,4a2.039,2.039,0,0,0-1-1,23.193,23.193,0,0,0-6.5-1,24.107,24.107,0,0,0-6.5,1,1.768,1.768,0,0,0-1,1c-.448.9-.752,3.966-.5,8.01a42.092,42.092,0,0,0,.718,5.757,3,3,0,0,0,1.275,1.9L6.591,20h0v1.5a1.075,1.075,0,0,0,1,1,1,1,0,0,0,1-1V20h7v1.5a1,1,0,1,0,2,0V20l.5-.333a3,3,0,0,0,1.277-1.9,42.8,42.8,0,0,0,.724-5.777C20.337,8.043,20.053,4.924,19.591,4Zm-12,15.5a.5.5,0,0,1,.5.5v1.5a.5.5,0,0,1-1,0V20A.5.5,0,0,1,7.591,19.5Zm9,0a.5.5,0,0,1,.5.5v1.5a.5.5,0,0,1-1,0V20A.5.5,0,0,1,16.591,19.5ZM6.091,10V6a1,1,0,0,1,1-1h4v5Zm2,3.5a2,2,0,1,1-2,2A2,2,0,0,1,8.091,13.5Zm8,0a2,2,0,1,1-2,2A2,2,0,0,1,16.091,13.5Zm-8,1a1,1,0,1,0,1,1A1,1,0,0,0,8.091,14.5Zm8,0a1,1,0,1,0,1,1A1,1,0,0,0,16.091,14.5Zm1-9.5a1,1,0,0,1,1,1v4h-5V5Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrain);
export default __webpack_public_path__ + "static/media/train.d10bca028ef9aa931b9976e3b9546bbc.svg";
export { ForwardRef as ReactComponent };